module.exports = __webpack_public_path__ + "static/media/2009-stm.b8fbd77f.jpg";